import { usePopupManager } from 'react-popup-manager/dist/src'

import { SizeModal } from '@Components/SizeModal/index'
import { Product } from '@Generated/graphql'
import { useMParticle } from '@Globals/MParticle/useMParticle'
import { useFilteredVariants } from '@Globals/Product/useFilteredVariants'
import { useTranslation } from '@Globals/Translations'

type UseSizeSelectorHookProps = {
  preselectedID?: string
  product: Product
}

export const useSizeSelectorModal = ({
  preselectedID = '',
  product,
}: UseSizeSelectorHookProps): () => Promise<string | undefined> => {
  const { t } = useTranslation()
  const { open: openPopup } = usePopupManager()
  const { variantsInTotal } = useFilteredVariants({ product })
  const { otherEvent } = useMParticle()

  // only works as long as the product was fetched with all variants (including unavailable)
  if (variantsInTotal > 1) {
    return () => new Promise((accept, reject) => {
      const sizeModalInstance = openPopup(SizeModal, {
        chooseOptionText: t('cms:CHOOSE_AN_OPTION'),
        onHide: () => {
          sizeModalInstance.close()
          reject()
        },
        onSelect: (selectedSize: string) => {
          accept(selectedSize)
          sizeModalInstance.close()
        },
        preselectedID,
        product,
      })

      otherEvent({
        eventName: 'product_size_overlay_open',
        attributes: {
          source_id: 'inherit',
        },
      })
    })
  }

  return () => Promise.resolve(product.id)
}
